import { clsx } from "clsx";

export function cn(...inputs) {
  return clsx(inputs);
}

// Browser detection utilities
export function isSafari() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}

export function isSafariMobile() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

export function getBrowserInfo() {
  const userAgent = navigator.userAgent;
  const isSafariBrowser = isSafari();
  const isMobileSafari = isSafariMobile();
  
  return {
    isSafari: isSafariBrowser,
    isMobileSafari: isMobileSafari,
    userAgent: userAgent
  };
}
